const AppStrings = {
  STATUS: "STATUS",
  // Ten: "Checkout",
  // Eleven: "Checkoutone",
  // Twelve: "Checkouttwo",
  USER_ID: "USER_ID",
  NavFine: "NavFine",
  LOGIN_DATA: "LOGIN_DATA",
  SELECTED_LOCATION: "SELECTED_LOCATION",
  AUTH_TOKEN: "AUTH_TOKEN",
  LOGIN_SKIP: "LOGIN_SKIP",
  PRICE_SYMBOL: "₹",
  All: "All",
  Categories: "Categories",
  Items: "Items",
  DEVICE_TOKEN: "DEVICE_TOKEN",
  APP_NAME: "MY_ZAMZAM",
  VERSION: "1.0",
  CHECK_LOGIN_STATUS: "CHECK_LOGIN_STATUS",
};

export default AppStrings;